// extracted by mini-css-extract-plugin
module.exports = {"root":"_2SJVDY1VkqLn0TG8NsXLmy","loader-rotation":"_3gYzECMW_GSaTuetuDGH0d"};